/*
 * Calculate space value
 * ========================================
 */

let space = window.location.hostname.split('.')[0];
if (space === 'localhost') {
  space = 'shrub';
}

export default space;
